import React, { useState, useEffect } from 'react';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import useVirtualAppointmentFormMutation from './hooks/useVirtualAppointmentFormMutation';

function VirtualAppointmentForm() {
  const { Button, Grid, InputMui, InputLabel, TextField, InputMask } = useUiContext();

  const { mutate } = useVirtualAppointmentFormMutation();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(null);
  const [isPhoneNoValid, setIsPhoneNoValid] = useState(null);
  const [phoneNo, setPhoneNo] = useState('');

  const validateEmailFormat = (e) => {
    const regEmail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    const valid = regEmail.test(e);
    setIsEmailValid(valid);
    return valid;
  };

  const validatePhoneNo = (p) => {
    const regPhoneNo = /_/;
    const valid = !regPhoneNo.test(p) && p !== '';
    setIsPhoneNoValid(valid);
    return valid;
  };

  const showHelperText = (validState, copy) => {
    if (validState == null) {
      return false;
    }

    if (!validState) {
      return copy;
    }

    return null;
  };

  useEffect(() => {
    if (email !== '') {
      validateEmailFormat(email);
    }
  }, [email]);

  useEffect(() => {
    if (phoneNo) {
      validatePhoneNo(phoneNo);
    }
  }, [phoneNo]);

  const mySetEmail = (e) => {
    setEmail((e.target.value).trim());
    validateEmailFormat(e.target.value);
  };

  const handleSubmit = () => {
    const input = {
      firstName,
      lastName,
      email,
      phoneNumber: phoneNo,
    };

    mutate(input);
  };

  const valid = !!(isEmailValid && firstName && lastName && isPhoneNoValid);

  return (
    <div className="form-container">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <InputLabel className="form-label">Email *</InputLabel>
          <InputMui
            fullWidth
            value={email}
            name="email"
            onChange={mySetEmail}
            required="true"
            helperText={showHelperText(isEmailValid, 'Please enter a valid email address')}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel className="form-label">First Name *</InputLabel>
          <InputMui
            fullWidth
            value={firstName}
            name="firstName"
            onChange={(e) => setFirstName((e.target.value).trim())}
            required="true"
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel className="form-label">Last Name *</InputLabel>
          <InputMui
            fullWidth
            value={lastName}
            name="lastName"
            onChange={(e) => setLastName((e.target.value).trim())}
            required="true"
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel className="form-label">Phone Number</InputLabel>
          <InputMask
            name="phoneNo"
            mask="+1 (999) 999-9999"
            value={phoneNo}
            onChange={(e) => setPhoneNo((e.target.value).trim())}
          >
            {() => (
              <TextField
                variant="outlined"
                type="text"
                fullWidth
                value={phoneNo}
                name="phoneNo"
                required="true"
                helperText={showHelperText(isPhoneNoValid, 'Please enter a valid phone number')}
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={12}>
          <div className="form-btn primary-btn">
            {valid && (<Button fullWidth onClick={handleSubmit}>
              Book your virtual Appointment
            </Button>)}
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default VirtualAppointmentForm;
